import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SiteMembers } from './siteMembers'
import { ComponentWillMountSymbol } from 'feature-components'
import { SocialAuthWillMount } from './socialAuthWillMount'
import { SiteMembersApiSymbol } from '../symbols'
import { LifeCycle, TpaHandlerProviderSymbol } from '@wix/thunderbolt-symbols'
import { SiteMembersTPAHandlers } from '../tpaHandlers'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { SiteMembersSideEffects } from './siteMembersSideEffects'

export const editor: ContainerModuleLoader = (bind) => {
	bind(SiteMembersApiSymbol, LifeCycle.AppWillMountHandler).to(SiteMembers)
	bind(ModelUpdatesHandlersImplementor).to(SiteMembersSideEffects)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(TpaHandlerProviderSymbol).to(SiteMembersTPAHandlers)
	bind(ComponentWillMountSymbol).to(SocialAuthWillMount)
}
